import React from 'react';

import styles from './OtherOptions.module.scss';
import { appendBasePath } from '../../../utils/nav.utils';
import { getExistingAutomatics } from '../../../redux/modules/existingAutomatics/existingAutomatics.selectors';
import { useSelector } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router';
import { getRMDSummary } from '../../../redux/modules/RMD/RMDSetting.selectors';
import { getOnlyOWNRRMDs } from '../../../redux/modules/UserFunds/userFunds.selectors';
import CTATiles from '../../../containers/Dashboard/CTATiles';

const OtherOptions = ({ history }) => {
  const existingAutomatics = useSelector(getExistingAutomatics);
  const hasRMD = useSelector(getOnlyOWNRRMDs);
  const hasSingleSellDistribution = existingAutomatics.autoSells;
  const hasSingleExchangeDistribution = existingAutomatics.autoExchanges;
  const userNoDistributions =
    Object.values(hasSingleSellDistribution).length === 0 &&
    Object.values(hasSingleExchangeDistribution).length === 0;
  const rmdSummary = useSelector(getRMDSummary);
  return (
    <div className={styles['container']} id="other-options">
      <div>
        {hasRMD.length === 0 && (
          <div>
            <div className={styles['title']}>
              Let us handle your RMD for you.
            </div>
            <div className={styles['sub-heading-1']}>
              Never miss your RMD with recurring distributions that
              automatically adjust each year. Set up multiple yearly payments or
              take it all in one distribution.
            </div>
            <div className={styles['set-up']}>
              <button
                id={'otherOptions-enable-auto-RMD'}
                className={styles['buttonBorder']}
                onClick={(e) => history.push(appendBasePath('/start'))}
              >
                Set Up Auto-RMD
              </button>
            </div>
          </div>
        )}
        {!userNoDistributions && hasRMD.length === 0 && (
          <div className={styles['sub-title']}>
            You can also take care of your RMD on your own.
          </div>
        )}
        {((userNoDistributions && hasRMD.length === 0) ||
          rmdSummary.actualDistributionTotal >= rmdSummary.totalRMD ||
          hasRMD.length !== 0) && (
          <div className={styles['sub-title']}>Other ways to take your RMD</div>
        )}
      </div>
      <div className={styles['sub-heading-1']}>
        You’ve got options when it comes to how you want to handle your RMD, and
        we make it easy to find the solution that best fits your goals. If you
        don’t need your RMD for living expenses, T. Rowe Price can help you:
      </div>
      <CTATiles preRMD={false} />
    </div>
  );
};

export default compose(withRouter)(OtherOptions);
